export function getDomain(url: string, level = 2) {
    const parts = url
        .split('/')
        .filter((part) => part.includes('.'))[0]
        ?.split('.');
    const domainName = parts?.slice(-level).join('.');
    return `.${domainName}`;
}
